module.exports = __webpack_public_path__ + "assets/img/btn-detail-a3582903.png";